



























































































import axios from 'axios';
import Vue from 'vue';
import EventBus from '@/eventBus';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoCardPlan from '@/components/Molecules/co-card-plan/CoCardPlan.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import { filter } from 'lodash';

export default {
    name: 'PlansList',
    components: {
        CoCard,
        CoCardPlan,
        CoRoundButton,
        CoDropdown,
        CoDropdownItem,
        CoHeadline,
        CoButton,
    },
    data() {
        return {
            loading: false,
            feed: [],
            search: '',
            filter: 'Active',
        };
    },
    mounted() {
        this.getPlans();
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        filteredItems() {
            if (!this.filter && !this.search) {
                return this.feed;
            }
            return filter(this.feed, (item) => {
                let matchesFilter = true;
                let matchesSearch = true;

                // filter
                if (this.filter === 'Active') {
                    matchesFilter = item.Active === true;
                } else if (this.filter === '!Active') {
                    matchesFilter = !item.Active;
                } else if (this.filter === 'Hidden') {
                    matchesFilter = item.Hidden || !item.Active;
                } else if (this.filter === '!Hidden') {
                    matchesFilter = !item.Hidden && item.Active === true;
                }

                // search by plan name
                if (this.search && this.search.length > 0) {
                    const searchLower = this.search.toLowerCase();
                    matchesSearch = (item.Name && item.Name.toLowerCase().includes(searchLower)) || false;
                }

                return matchesFilter && matchesSearch;
            });
        },
    },
    methods: {
        copyValueToClipboard(id) {
            const link = `https://${this.$store.state.space.DomainName}/plans/${id}`;
            navigator.clipboard.writeText(link);
            EventBus.$emit('INFO', {
                Message: this.$t('messages.copiedtoclipboard'),
                Details: '',
            });
        },
        viewPlan(id) {
            this.$router.push(`/admin/monetization/plan/${id}`);
        },
        editPlan(id) {
            this.$router.push(`/admin/monetization/plan/edit/${id}`);
        },
        duplicate(item) {
            const duplicatePlan = JSON.parse(JSON.stringify(item));

            duplicatePlan.ID = null;
            duplicatePlan.Name = `${duplicatePlan.Name} (${this.$t('labels.copySuffix')})`;
            duplicatePlan.ImageURL = null;
            duplicatePlan.Hidden = true;

            axios({
                method: 'POST',
                url: '/admin/plan/create',
                data: duplicatePlan,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.planDuplicateCreated'),
                        Details: '',
                    });
                    this.loading = false;
                    this.$router.push(`/admin/monetization/plan/${response.data.ID}`);
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.planDuplicateCreateFailed'),
                        Details: error,
                    });
                    this.loading = false;
                });

            this.loading = false;
        },
        // compile dynamic asset reference
        getPlans() {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/plan/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        response.data.Plans.forEach((element) => {
                            this.feed.push(element);
                        });
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
    },
};
